
import type { StateCreator } from 'zustand';
import type { StoreState } from '..';
import { getAppSettings } from './api';

export interface AppSlice {
  activityLoader: boolean;
  expandSidebar: boolean;
  globalSettings: any;
  currentPage: string;
  initializeApp: () => void;
  setCurrentPage: (page: string) => void;
  setActivityLoader: (value: boolean) => void;
  loadGlobalSettings: () => void;
  setExpandSidebar: (value: boolean) => void;
  clearApp: () => void;
}

export const createAppSlice: StateCreator<
  StoreState,
  [],
  [],
  AppSlice
> = (set, get) => ({
  activityLoader: false,
  currentPage: "EDIT",
  expandSidebar: false,
  globalSettings: {},
  
  setActivityLoader: (value: boolean) => set({ activityLoader: value }),
  setCurrentPage: (value: string) => set({ currentPage: value }),
  loadGlobalSettings: async () => {
    set(() => ({ activityLoader: true }))
    try {
      const response: any = await getAppSettings();
      const { globalSettings } = response.data;
      set(() => ({ globalSettings }))
    } catch (e) {
      set(() => ({ activityLoader: false }));
      throw e;
    } finally {
      set(() => ({ activityLoader: false }))
    }
  },
  setExpandSidebar: (value: boolean) => set({ expandSidebar: value }),
  initializeApp: async() => {
    set(()=>({activityLoader: true}));
    const [globalSettings] = await Promise.all([getAppSettings()])
    set(() => ({ globalSettings: globalSettings.data}));
  },
  clearApp: () => {
    set(() => ({
      globalSettings: {},
      activityLoader: false,
    }));
  },
});
